import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipContentComponent } from './tooltip-content.component';
import { TooltipComponent } from './tooltip.component';

@NgModule({
  imports: [CommonModule, PortalModule, OverlayModule],
  declarations: [TooltipComponent, TooltipContentComponent],
  exports: [TooltipComponent, TooltipContentComponent],
})
export class TooltipModule {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/tooltip/tooltip.module.ts